<template>
  <section class="page-dashboard-my-payment pt-3">
    <app-loading :isFull="true" v-if="isLoading"/>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header class="mb-3">
            <h2 class="font-18 text-right">سوابق مالی</h2>
          </header>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-card no-body class="mb-5">
            <b-tabs card>
              <b-tab  @click="getMyBillReuslt(1)" title="لیست تراکنش های من">
                <listTransaction/>
              </b-tab>
              <b-tab @click="getEarn(1)" title="جزییات درآمد مدرس" v-if="isInstructor">
                <adjustment/>
              </b-tab>
              <b-tab title="تسویه حساب" v-if="isInstructor">
                <requestCash/>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import listTransaction from 'cp/dashboard-component/my-payment/list-transaction.vue'
import listTransactionAll from 'cp/dashboard-component/my-payment/list-transaction-all.vue'
import adjustment from 'cp/dashboard-component/my-payment/adjustment.vue'
import adjustmentAll from 'cp/dashboard-component/my-payment/adjustment-all.vue'
import requestCash from 'cp/dashboard-component/my-payment/request-cash.vue'
import listPaidTrue from 'cp/dashboard-component/my-payment/list-paid-true.vue'
import listPaidFalse from 'cp/dashboard-component/my-payment/list-paid-false.vue'

export default {
  name: 'page-dashboard-my-payment',
  components: {
    listTransaction,
    adjustment,
    listTransactionAll,
    adjustmentAll,
    requestCash,
    listPaidTrue,
    listPaidFalse
  },
  data() {
    return {
      isInstructor: false,
      isLoading: false
    }
  },
  computed: {
    level() {
      return this.$store.state.auth.level
    }
  },
  async mounted() {
    this.getMyBillReuslt(1)
    this.isInstructor = await this.checkAccess(false)
  },
  methods: {
    async getMyBillReuslt(p) {
      this.isLoading = true
      await this.$store.dispatch('Daccounting/getLstMyTransaction', { p })
      this.isLoading = false
    },
    async  getEarn(p) {
      this.isLoading = true
      await this.$store.dispatch('Daccounting/getMyEarnList', { p })
      this.isLoading = false
    }
  },
  destroyed() {
    this.$store.commit('Daccounting/clear')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/dashboard/my-payment.vue